import './modules/top'
import './modules/archive'
import './modules/single'

window.addEventListener('load', function () {
  // 二重初期化防止用フラグ
  let inited = false
  const initAfterLoaded = () => {
    if (inited) return
    inited = true

    // ===== ここから下が「.is-loaded 付与後」に実行される処理 =====

    // SP: ナビ開閉
    if (window.matchMedia('(max-width: 900px)').matches) {
      const navTrigger = document.querySelector('.js_nav_trigger')
      const nav = document.querySelector('.js_nav_target')
      const thisBody = document.body

      const closeNav = () => {
        thisBody.classList.remove('scroll_stop')
        nav?.classList.remove('is-current')
      }

      if (navTrigger && nav) {
        navTrigger.addEventListener('click', () => {
          thisBody.classList.toggle('scroll_stop')
          nav.classList.toggle('is-current')
        })
        nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeNav))
      }

      document.addEventListener('click', function (e) {
        const nav = document.querySelector('nav.js_nav_target')
        if (!nav) return
        if (!nav.contains(e.target)) return

        // クリック対象が li 直下の <p> かどうか判定
        const p = e.target.closest('li > p')
        if (!p || !nav.contains(p)) return

        const submenu = p.nextElementSibling
        if (!submenu || submenu.tagName !== 'UL') return

        // トグル（この行だけで要件は満たせる）
        submenu.classList.toggle('is-current')
      })
    }

    // アンカーのスムーススクロール
    document.querySelectorAll('a[href*="#"]').forEach((link) => {
      link.addEventListener('click', function (e) {
        const href = this.getAttribute('href')
        if (!href) return
        const url = new URL(href, location.href)
        const thishash = url.hash
        if (!thishash) return
        const target = document.querySelector(thishash)
        if (!target) return

        e.preventDefault()
        const offset = 100
        const top = target.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({ top, behavior: 'smooth' })
      })
    })

    // inview: 一度だけ .is-show 付与
    ;(() => {
      const targets = document.querySelectorAll('.inview')
      if (!targets.length) return
      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            entry.target.classList.add('is-show')
            observer.unobserve(entry.target)
          })
        },
        {
          root: null,
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.1,
        },
      )
      targets.forEach((el) => io.observe(el))
    })()

    const form = document.getElementById('gsite-search')
    const input = document.getElementById('gsite-q')
    if (!form || !input) return

    form.addEventListener('submit', function (e) {
      const cleaned = (input.value || '').replace(/[\s\u3000]+/g, '')
      if (!cleaned.length) {
        e.preventDefault()

        input.focus()
      }
    })
    // ===== ここまで「.is-loaded 後」 =====
  }

  // ここで .is-loaded を付け、付与“後”に初期化を走らせる
  setTimeout(() => {
    document.documentElement.classList.add('is-loaded')
    initAfterLoaded()
  }, 500)
})
